<template>
  <div
    class="fixed top-0 left-0 z-20 w-full"
    :style="{
      boxShadow: hasSubcategories ? null : '0px 4px 15px rgba(0, 0, 0, 0.2)'
    }"
  >
    <div class="relative flex items-center justify-between bg-primary-purple top-block">
      <div class="flex items-center flex-grow h-full">
        <a href="/" class="flex items-center h-full">
          <img
            src="https://s3.amazonaws.com/ma-content/images/2024/logo-light.png"
            alt="Motion Array"
            title="Motion Array"
            style="max-width: 130px;"
          />
        </a>
      </div>

      <CategoryLinks
        ref="categoryLinks"
        class="flex-1 h-full"
        :active="highlightedCategories"
        @hovered="onHoverCategory"
      />

      <UserLinks class="flex-grow" />
    </div>

    <BottomBlock
      v-show="hasSubcategories"
      ref="bottomBlock"
      :category="hoveredCategory || routeCategory"
    />
  </div>
</template>

<script>
import getContext from '@/utilities/get-context.js';
import CategoryLinks from "./category-links"
import UserLinks from "./user-links";
import BottomBlock from "./bottom-block";
import { getActiveCategory } from "../links";

export default {
  components: {
    CategoryLinks,
    UserLinks,
    BottomBlock,
  },

  data() {
    return {
      hoveredCategory: "",
    };
  },

  computed: {
    routeCategory() {
      return getActiveCategory(this.$route.path)
    },

    highlightedCategories() {
      const categories = [];

      if (this.routeCategory) {
        categories.push(this.routeCategory)
      }

      if (this.hoveredCategory) {
        categories.push(this.hoveredCategory)
      }

      return categories
    },

    hasSubcategories() {
      const categories = ['templates', 'presets', 'audio', 'videos', 'tools', 'images'];
      return categories.includes(this.hoveredCategory || this.routeCategory);
    },
  },

  mounted() {
    this.$el.addEventListener("mousemove", (evt) => {
      const isFromCategories = this.$refs.categoryLinks.$el.contains(evt.target)
      const isFromBottomBlock = this.$refs.bottomBlock.$el.contains(evt.target)

      if (!isFromCategories && !isFromBottomBlock) {
        this.hoveredCategory = "";
      }
    });

    this.$el.addEventListener("mouseleave", (evt) => {
      this.hoveredCategory = "";
    });
  },

  methods: {
    onHoverCategory(category) {
      this.hoveredCategory = category
    },
  }
};
</script>

<style scoped>
.top-block {
  height: 60px;
  padding-left: 20px;
  padding-right: 20px;
}
</style>
